<template>
  <div class="HubSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubSettings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.HubSettings_title1}}
        </template>
        <template v-slot:body>
          <div class="HubSettings-wrapper-colors lxn-w100">
            <div @click="activeBoxIndex = 0;" class="HubSettings-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
              <div class="HubSettings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 1;" class="HubSettings-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
              <div class="HubSettings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 2;" class="HubSettings-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
              <div class="HubSettings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 3;" class="HubSettings-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
              <div class="HubSettings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
            <div @click="activeBoxIndex = 4;" class="HubSettings-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
              <div class="HubSettings-selectedColor lxn-w100 lxn-h100 lxn-border-round">
              </div>
            </div>
          </div>
          <div class="HubSettings-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.HubSettings_text1}}
          </div>
          <div class="lxn-w100">
            <customInput @focus="inputState='active'" @blur="inputState=''" :inputState="inputState" v-model="currentHubName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddHubNameColor_placeHolder" inputType="text" />
          </div>
        </template>
      </TitleBox>
      <TitleBox v-if="isUserOwner" :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.HubSettings_title2}}
        </template>
        <template v-slot:body>
          <div class="HubSettings-wrapper-button lxn-margin-auto lxn-w100">
            <CustomButton @click="userManagement" bgColor="#1EA5DE" iconRight="user" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button4}}
            </CustomButton>
          </div>
          <div class="HubSettings-wrapper-button lxn-margin-auto lxn-w100">
            <CustomButton @click="networkSettings" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button5}}
            </CustomButton>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.HubSettings_title4}}
        </template>
        <template v-slot:body>
          <div class="HubSettings-wrapper-button lxn-margin-auto lxn-w100">
            <CustomButton @click="syncDatabase" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button6}}
            </CustomButton>
          </div>
          <div v-if="isUserOwner" class="HubSettings-wrapper-button lxn-margin-auto lxn-w100">
            <CustomButton @click="saveDatabase" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button7}}
            </CustomButton>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.HubSettings_title5}}
        </template>
        <template v-slot:body>
          <div v-if="isUserOwner" class="HubSettings-wrapper-button lxn-margin-auto lxn-w100">
            <CustomButton @click="addAlexa" bgColor="#1EA5DE" iconRight="alexa" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="4" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button8}}
            </CustomButton>
          </div>
          <div v-if="isUserOwner" class="HubSettings-wrapper-button lxn-margin-auto lxn-w100">
            <CustomButton @click="addGoogle" bgColor="#1EA5DE" iconRight="nest" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="4" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button9}}
            </CustomButton>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.HubSettings_title3}}
        </template>
        <template v-slot:body>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-right">
              {{uuid}}
            </div>
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-left">
              UUID
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{hubConnectionStatus}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              Connection Type
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{internetConnection}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              Hub Internet Connection
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{hubDate}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              Hub Date
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{hubTime}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              Hub Time
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{wifiName}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              WiFi Name
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{wifiType}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              WiFi Type
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-right">
              {{IP}}
            </div>
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-left">
              IP
            </div>
          </div>
          <div class="HubSettings-wrapper-status lxn-w100">
            <div class="HubSettings-wrapper-status-d1 lxn-title lxn-text-en lxn-float-right">
              {{firmWareVersion}}
            </div>
            <div class="HubSettings-wrapper-status-d0 lxn-title lxn-text-en lxn-float-left">
              Firmware Version
            </div>
          </div>
          <div v-if="isUserOwner" class="HubSettings-ota-button lxn-margin-auto lxn-w100">
            <CustomButton :disabled="isHubOffline || isHubNotConnectedToInternet" @click="otaUpdate" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
              {{$store.getters.language.texts.HubSettings_button3}}
            </CustomButton>
          </div>
        </template>
      </TitleBox>
    </div>
    <div class="HubSettings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.HubSettings_button}}
      </CustomButton>
    </div>
    <div class="HubSettings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="deleteDevice" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.HubSettings_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import md5 from 'md5'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'HubSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
      currentHubName: '',
      inputState: '',
      activeBoxIndex: this.$store.getters.getHubByUUID(this.$route.params.hubUUID).color,
      AccessPointName: '',
    }
  },
  mounted: function () {
    this.AccessPointName = this.$store.state.defaultWifiPrefix + messaging.utility.uuidToHexString(this.hub.uuid).toUpperCase();
    this.currentHubName = this.hubName;
    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    this.$store.dispatch('readHubParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid})
    .then( response => {
      console.log("hub ")
      console.log(this.hub)
      this.$store.commit('setHubStatus', {
        hubIndex: response.hubIndex,
        ipAddress:  this.hub.staticIp ?  this.hub.ipAddress : response.body.bodyContent.hubIP[0] + '.' + response.body.bodyContent.hubIP[1] + '.' + response.body.bodyContent.hubIP[2] + '.' + response.body.bodyContent.hubIP[3] ,
        firmWareYear: response.body.bodyContent.firmwareYear,
        firmWareMonth: response.body.bodyContent.firmwareMonth,
        isMQTTConnected: response.body.bodyContent.isMQTTConnected == 1 ? true : false,
        wifiType: response.body.bodyContent.wifiType == 0 ? "STA" : "AP",
        ssid: response.body.bodyContent.ssid,
        dateStamp: response.header.nonce.dateStamp,
        timeStamp: response.header.nonce.timeStamp,
      });
    })
    .catch( response => {
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
    });
  },
  computed: {
    isUserOwner: function () {
      return this.hub.isOwner;
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    hubName: function () {
      return this.hub.name;
    },
    hubConnectionStatus: function () {
      var localConnection = this.hub.connectionStatus.local;
      var onlineConnection = this.hub.connectionStatus.online;
      if(localConnection == 2 && onlineConnection == 2){
        return "Local & Online";
      }else if(localConnection == 2){
        return "Local";
      }else if(onlineConnection == 2){
        return "Online";
      }else if(localConnection == 1 || onlineConnection == 1){
        return "Connecting...";
      }else{
        return "Not Connected";
      }
    },
    internetConnection: function () {
      var internetConnection = this.hub.isMQTTConnected;
      return internetConnection ? "Yes" : "No";
    },
    isHubNotConnectedToInternet: function () {
      var internetConnection = this.hub.isMQTTConnected;
      return internetConnection == 0;
    },
    hubDate: function () {
      var hubDate = new Date(this.hub.dateStamp * 3600000 * 24 + this.hub.timeStamp);
      if(this.isHubOffline){
        return 'Not Connected';
      }else{
        return hubDate.toDateString();
      }
    },
    hubTime: function () {
      var hubTime = new Date(this.hub.dateStamp * 86400000 + this.hub.timeStamp);
      if(this.isHubOffline){
        return 'Not Connected';
      }else{
        return hubTime.toLocaleTimeString();
      }
    },
    wifiName: function () {
      if(this.isHubOffline){
        return 'Not Connected';
      }else{
        if(this.wifiType == "STA"){
          return this.hub.ssid;
        }else{
          return this.AccessPointName
        }
      }
    },
    wifiType: function () {
      if(this.isHubOffline){
        return 'Not Connected';
      }else{
        return this.hub.wifiType;
      }
    },
    IP: function () {
      return this.hub.ipAddress ? this.hub.ipAddress : 'xx.xx.xx.xx'
    },
    uuid: function () {
      return ("0000000" + this.hub.uuid.toString(16).toUpperCase()).slice(-8);
    },
    firmWareVersion: function () {
      var firmWareYear = ("0" + this.hub.firmWareYear).slice(-2);
      var firmWareMonth = ("0" + (this.hub.firmWareMonth & 0x0F)).slice(-2);
      var firmWareSubVersion = this.hub.firmWareMonth >> 4;
      var firmwareString = firmWareYear + '.' + firmWareMonth;
      if(firmWareSubVersion){
        firmwareString += '.' + firmWareSubVersion;
      }
      if(this.isHubOffline){
        return 'Not Connected';
      }else{
        return firmwareString;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.push('/home/devices/');
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.inputState = '';
      if(this.currentHubName == ''){
        this.inputState = 'error';
        alert(this.$store.getters.language.texts.HubSettings_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setHubName', {hubIndex: this.hub.index, name: this.currentHubName});
        this.$store.commit('setHubColor', {hubIndex: this.hub.index, color: this.activeBoxIndex});
        this.$store.commit('saveState');
        this.$router.push('/Home/Devices');
        this.$store.commit('setAppBusy', false);
      }
    },
    deleteDevice: function () {
      this.$router.push('/DeleteHub/' + this.hub.uuid);
    },
    otaUpdate: function () {
      this.$router.push('/OTA/' + this.hub.uuid);
    },
    userManagement: function () {
      this.$router.push('/hubUserSettings/' + this.hub.uuid);
    },
    networkSettings: function () {
      this.$router.push('/hubNetworkSettings/' + this.hub.uuid);
    },
    saveDatabase: function () {
      this.$store.commit('setAppBusy', true);
      this.$store.dispatch('saveDatabase', this.hub.uuid)
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response =>{
        if(response.errorCode == 1){
          alert(this.$store.getters.language.texts.HubSettings_serverError);
          this.$store.commit('setAppBusy', false);
        }else if(response.errorCode == 2){
          alert(this.$store.getters.language.texts.Common_internetError);
          this.$store.commit('setAppBusy', false);
        }
      })
    },
    syncDatabase: function () {
      this.$store.commit('setAppBusy', true);
      this.$store.dispatch('getSnapshot', {
        userUUID: this.$store.state.user.uuid,
        token: this.$store.state.user.loginToken,
        hubUUID: this.hub.uuid,
      })
      .then( response => {
        if(response.data.status == 'success'){
          if(this.hub.isOwner){
            var ownedSnapShots = response.data.snapshots.owned;
            if(ownedSnapShots.length > 0){
              var database = JSON.parse(decodeURI(ownedSnapShots[0].content));
              this.applySnapshot(database);
              this.$router.push('/home/devices/');
            }else{
              alert(this.$store.getters.language.texts.HubSettings_noSnapshotsFound);
            }
          }else{
            var sharedSnapShots = response.data.snapshots.shared;
            if(sharedSnapShots.length > 0){
              database = JSON.parse(decodeURI(sharedSnapShots[0].content));
              this.applySnapshot(database);
              this.$router.push('/home/devices/');
            }else{
              alert(this.$store.getters.language.texts.HubSettings_noSnapshotsFound);
            }
          }
          this.$store.commit('setAppBusy', false);
        }else{
          alert(this.$store.getters.language.texts.HubSettings_serverError);
          this.$store.commit('setAppBusy', false);
        }
      })
      .catch( () => {
        alert(this.$store.getters.language.texts.Common_internetError);
        this.$store.commit('setAppBusy', false);
      })
    },
    applySnapshot: function (database) {
      this.$store.commit('setHubName', {hubIndex: this.hub.index, name: database.hub.name});
      this.$store.commit('setHubColor', {hubIndex: this.hub.index, color: database.hub.color});
      var nodeCount = this.$store.state.nodes.length;
      for(var i = nodeCount - 1; i >= 0; i--){
        if(this.$store.state.nodes[i].hubUUID == this.hub.uuid){
          this.$store.commit('deleteNode', i);
        }
      }
      for(i = 0; i < database.nodes.length; i++){
        this.$store.commit('addNode', database.nodes[i]);
      }
      var widgetsCount = this.$store.state.widgets.length;
      for(i = widgetsCount - 1; i >= 0; i--){
        if(this.$store.state.widgets[i].hubUUID == this.hub.uuid){
          this.$store.commit('deleteWidget', i);
        }
      }
      for(i = 0; i < database.widgets.length; i++){
        if(database.widgets[i].type == "folderWidget"){
          if(this.$store.state.widgets.filter(widget => widget.settings.path == database.widgets[i].settings.path).length == 0){
            this.$store.commit('addWidget', database.widgets[i]);
          }
        }else{
          this.$store.commit('addWidget', database.widgets[i]);
        }
      }
      if(database.schedules != undefined){
        var schedulesCount = this.$store.state.schedules.length;
        for(i = schedulesCount - 1; i >= 0; i--){
          if(this.$store.state.schedules[i].hubUUID == this.hub.uuid){
            this.$store.commit('deleteSchedule', i);
          }
        }
        for(i = 0; i < database.schedules.length; i++){
          this.$store.commit('addSchedule', database.schedules[i]);
        }
      }
      if(this.hub.isOwner){
        this.$store.commit('setAllHubUsers', {hubIndex: this.hub.index, users:  database.users});
      }
      this.$store.commit("saveState");
    },
    addAlexa: function () {
      this.$store.commit('setAppBusy', true);
      CONFIGS.alexaBaseURL
      var userUUID = CONFIGS.alexaUUID;
      if(this.$store.getters.getUserByUUID(this.hub.index, userUUID) != -1){
        alert(this.$store.getters.language.texts.AddNewUser_alert3);
        this.$store.commit('setAppBusy', false);
      }else{
        var uuids = [];
        for(var i = 0; i < this.hub.users.length; i++){
          if(!this.hub.users[i].isOwner){
            uuids.push(this.hub.users[i].uuid);
          }
        }
        uuids.push(userUUID);
        this.$store.dispatch('grantSnapshotAccess', {
          userUUID: this.$store.state.user.uuid,
          token: this.$store.state.user.loginToken,
          hubUUID: this.hub.uuid,
          uuids: uuids,
        })
        .then(response => {
          if(response.data.status == 'success'){
            var messagingHook = new Messaging(new Logger(false));
            var generatedPassword = Math.floor(Math.random()*90000) + 10000;
            generatedPassword = generatedPassword.toString();
            messagingHook.init({
              psk: this.hub.psk,
              destinationUUID: this.hub.uuid,
              sourceUUID: this.$store.state.user.uuid
            });
            this.$store.dispatch('addUserToHub', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              bodyContent: {
                newUserUUID: userUUID,
                password: md5(generatedPassword),
              }
            })
            .then( () => {
              this.$store.commit('addNewUserToHub', {hubIndex: this.hub.index, uuid: userUUID,name: "Amazon Alexa", isOwner: false,mobile: '-'});
              this.$store.commit('saveState');
              this.$store.dispatch('addAlexa', {
                userUUID: this.$store.state.user.uuid,
                token: this.$store.state.user.loginToken,
                hubUUID: this.hub.uuid,
                password: md5(generatedPassword),
              })
              .then( (response) => {
                if(response.data.status == 'success'){
                  alert(this.$store.getters.language.texts.AddAlexa_Success);
                }else{
                  alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
                }
              })
              .catch( () => {
                alert(this.$store.getters.language.texts.Common_internetError);
              })
              .finally( () => {
                this.$store.commit('setAppBusy', false);
              });
            })
            .catch( response => {
              if(response.rejectCode == 2){
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }
              this.$router.push('/SettingsHubError');
              this.$store.commit('setAppBusy', false);
            });
          }else{
            alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
            this.$store.commit('setAppBusy', false);
          }
        })
        .catch(() => {
          alert(this.$store.getters.language.texts.Common_internetError);
          this.$store.commit('setAppBusy', false);
        });
      }
    },
    addGoogle: function () {
      this.$store.commit('setAppBusy', true);
      CONFIGS.alexaBaseURL
      var userUUID = CONFIGS.nestUUID;
      if(this.$store.getters.getUserByUUID(this.hub.index, userUUID) != -1){
        alert(this.$store.getters.language.texts.AddNewUser_alert3);
        this.$store.commit('setAppBusy', false);
      }else{
        var uuids = [];
        for(var i = 0; i < this.hub.users.length; i++){
          if(!this.hub.users[i].isOwner){
            uuids.push(this.hub.users[i].uuid);
          }
        }
        uuids.push(userUUID);
        this.$store.dispatch('grantSnapshotAccess', {
          userUUID: this.$store.state.user.uuid,
          token: this.$store.state.user.loginToken,
          hubUUID: this.hub.uuid,
          uuids: uuids,
        })
        .then(response => {
          if(response.data.status == 'success'){
            var messagingHook = new Messaging(new Logger(false));
            var generatedPassword = Math.floor(Math.random()*90000) + 10000;
            generatedPassword = generatedPassword.toString();
            messagingHook.init({
              psk: this.hub.psk,
              destinationUUID: this.hub.uuid,
              sourceUUID: this.$store.state.user.uuid
            });
            this.$store.dispatch('addUserToHub', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              bodyContent: {
                newUserUUID: userUUID,
                password: md5(generatedPassword),
              }
            })
            .then( () => {
              this.$store.commit('addNewUserToHub', {hubIndex: this.hub.index, uuid: userUUID,name: "Google Nest", isOwner: false,mobile: '-'});
              this.$store.commit('saveState');
              this.$store.dispatch('addNest', {
                userUUID: this.$store.state.user.uuid,
                token: this.$store.state.user.loginToken,
                hubUUID: this.hub.uuid,
                password: md5(generatedPassword),
              })
              .then( (response) => {
                if(response.data.status == 'success'){
                  alert(this.$store.getters.language.texts.AddNest_Success);
                }else{
                  alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
                }
              })
              .catch( () => {
                alert(this.$store.getters.language.texts.Common_internetError);
              })
              .finally( () => {
                this.$store.commit('setAppBusy', false);
              });
            })
            .catch( response => {
              if(response.rejectCode == 2){
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }
              this.$router.push('/SettingsHubError');
              this.$store.commit('setAppBusy', false);
            });
          }else{
            alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
            this.$store.commit('setAppBusy', false);
          }
        })
        .catch(() => {
          alert(this.$store.getters.language.texts.Common_internetError);
          this.$store.commit('setAppBusy', false);
        });
      }
    }
  },
}
</script>

<style>
  .HubSettings-topCurve-wrapper {
    height: 200px;
  }
  .HubSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .HubSettings-ota-button {
    margin-top: 14px;
  }
  .HubSettings-wrapper-button {
    margin-top: 14px;
  }
  .HubSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .HubSettings-wrapper-colors {
    height: 50px;
  }
  .HubSettings-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .HubSettings-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .HubSettings-color.active .HubSettings-selectedColor {
    opacity: 1;
  }
  .HubSettings-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .HubSettings-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .HubSettings-wrapper-status {
    height: 30px;
    color: #53636C;
    margin-top: 14px;
  }
  .HubSettings-wrapper-status-d0 {
    line-height: 30px;
  }
  .HubSettings-wrapper-status-d1 {
    line-height: 30px;
  }
</style>
